import { NotificationState } from '@/interfaces/states/notification-state.interface';

const state: NotificationState = {
  error: null,
  success: null,
};

export default state;
